import React, { useEffect, useState } from 'react';
import { Clock } from 'lucide-react';
export function CountdownTimer() {
  // Start with 12 mins 3 secs as in the reference
  const [timeLeft, setTimeLeft] = useState({
    hours: 0,
    minutes: 12,
    seconds: 3
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) {
          return {
            ...prev,
            seconds: prev.seconds - 1
          };
        } else if (prev.minutes > 0) {
          return {
            ...prev,
            minutes: prev.minutes - 1,
            seconds: 59
          };
        } else if (prev.hours > 0) {
          return {
            hours: prev.hours - 1,
            minutes: 59,
            seconds: 59
          };
        }
        // Reset when it hits 0 for demo purposes
        return {
          hours: 0,
          minutes: 15,
          seconds: 0
        };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const formatTime = (value: number) => value.toString().padStart(2, '0');
  return <div className="flex items-center justify-center space-x-3 my-6" data-id="element-26">
      <Clock className="w-5 h-5 text-primary" data-id="element-27" />
      <div className="flex items-center space-x-2 font-mono text-lg font-bold" data-id="element-28">
        <div className="bg-surface border border-primary/30 px-3 py-1 rounded-md text-primary glow-text" data-id="element-29">
          {formatTime(timeLeft.hours)}h
        </div>
        <span className="text-primary/50" data-id="element-30">:</span>
        <div className="bg-surface border border-primary/30 px-3 py-1 rounded-md text-primary glow-text" data-id="element-31">
          {formatTime(timeLeft.minutes)}m
        </div>
        <span className="text-primary/50" data-id="element-32">:</span>
        <div className="bg-surface border border-primary/30 px-3 py-1 rounded-md text-primary glow-text" data-id="element-33">
          {formatTime(timeLeft.seconds)}s
        </div>
      </div>
    </div>;
}